<div class="form-context-menu" [class.has-accept-button]="isEditing() && hasQuestionType()">
  @if (showSortAndDelete()) {
    <div
      class="menu-icon-button drag-handle"
      draggable="true"
      (dragstart)="onDragStart($event)"
      (dragend)="onDragEnd()"
      role="button"
      tabindex="0"
      aria-label="Sort">
      <span class="material-symbols-outlined">drag_indicator</span>
      <span class="add-tooltip">Drag to Reorder</span>
    </div>
    <button
      type="button"
      class="menu-icon-button"
      (click)="handleDelete($event)"
      aria-label="Delete">
      <i class="pi pi-trash"></i>
      <span class="add-tooltip">Delete This Question</span>
    </button>
  }
  <button
    type="button"
    class="menu-icon-button"
    (click)="handleInsertBelow()"
    aria-label="Insert question below">
    <span class="material-symbols-outlined">add_row_below</span>
    <span class="add-tooltip">Add Form Element Below</span>
  </button>
  @if (isEditing() && hasQuestionType()) {
    <button
      type="button"
      class="menu-icon-button"
      (click)="handleAccept()"
      aria-label="Accept and preview">
      <i class="pi pi-check"></i>
      <span class="add-tooltip">Accept and Preview</span>
    </button>
  }
  @if (!isEditing()) {
    <button
      type="button"
      class="menu-icon-button"
      (click)="handleEdit()"
      aria-label="Edit question">
      <i class="pi pi-pencil"></i>
      <span class="add-tooltip">Edit Question</span>
    </button>
  }
</div>

